export const hasTrailingSlash = (pathname: string): boolean =>
  pathname.slice(-1) === '/';

export const ensureTrailingSlash = (pathname: string): string =>
  hasTrailingSlash(pathname) ? pathname : `${pathname}/`;
